import { langExports } from "../translations/translationMain.js";
import { useSelector, useDispatch } from "react-redux";
import { actions as systemActions } from "../store/slices/systemSlice.js";
import BaseDropdown2 from "../baseComponents/baseDropdown2.js";

const LanguageSelector = (props) => {
  //constants
  const dispatch = useDispatch();

  //redux states
  const dictionaryState = useSelector((state) => state.dictionaryState);
  const currentLang = useSelector((state) => state.systemState.lang);
  const vCurrentLang = dictionaryState.translations[currentLang];
  const languagesInArray = Object.entries(dictionaryState.translations);
  const currentLangExpanded = languagesInArray.find((lang) => {
    return lang[1]?.shortName === vCurrentLang?.shortName;
  });

  //handlinFunctions
  const handleClick = (pLang) => {
    dispatch(systemActions.setSystemLanguage({ lang: pLang }));
  };

  if (languagesInArray.length < 2) {
    return;
  }

  if (!currentLangExpanded) {
    return;
  }

  return (
    <>
      <BaseDropdown2
        hasFormWrapper={false}
        value={currentLangExpanded[0]}
        style={{ paddingBottom: "2px", ...props.style }}
        onChange={handleClick}
        translate={false}
        elements={languagesInArray.map((lang) => {
          const value = lang[0];
          return {
            key: value,
            value: value,
            name: lang[1].shortName,
            isCurrent: value === currentLang,
          };
        })}
      />
    </>
  );
};

export default LanguageSelector;
